import { createA11ySdk } from '../../../utils/velo/a11ySdk';
import {
  transformPropDataToSdkData,
  transformSdkDataToPropData,
} from './sdkUtils/transformers';
import { registerCorvidMouseEvent } from '../../../common/sdk/corvidEvents';
import { composeSDKFactories } from '../../../utils/velo/composeSdks';
import { LinkUtilsDefinition } from '@wix/viewer-service-link-utils';
import type {
  MenuDataItem,
  MenuItemProps,
} from '@wix/thunderbolt-components-native';
import { createMenuDataItem, validateMenuItems } from './utils';
import type {
  CorvidSDKFactory,
  ICorvidMouseEvent,
  ICorvidEventHandler,
} from '@wix/editor-elements-types/corvid';

const createMenuSdk: CorvidSDKFactory = api => {
  const { props, setProps, getService } = api;
  const linkUtils = getService(LinkUtilsDefinition);
  return {
    get type() {
      return '$w.Menu';
    },
    get menuItems() {
      const menuDataItems = (props.elementProps?.navbar?.items?.map(
        transformPropDataToSdkData,
      ) ?? []) as Array<MenuDataItem>;
      return (
        menuDataItems?.map((menuItem, i) =>
          // TODO: get pageList from sdkData
          createMenuDataItem(menuItem, i, linkUtils, {}),
        ) ?? []
      );
    },
    set menuItems(menuDataItems: Array<MenuDataItem>) {
      const isValidMenuItems = validateMenuItems(menuDataItems);
      if (!isValidMenuItems) {
        return;
      }
      const updatedMenuItems =
        menuDataItems
          ?.map((menuItem, i) =>
            // TODO: get pageList from sdkData
            createMenuDataItem(menuItem, i, linkUtils, {}),
          )
          .map(transformSdkDataToPropData) ?? [];
      setProps({
        elementProps: {
          ...props.elementProps,
          navbar: { ...props.elementProps.navbar, items: updatedMenuItems },
        },
      });
    },
    onItemMouseIn: (handler: ICorvidEventHandler<ICorvidMouseEvent>) =>
      registerCorvidMouseEvent<MenuItemProps>(
        'onItemMouseIn',
        api,
        handler,
        payload => ({
          item: transformPropDataToSdkData(payload),
          type: 'itemMouseIn',
        }),
      ),
    onItemMouseOut: (handler: ICorvidEventHandler<ICorvidMouseEvent>) =>
      registerCorvidMouseEvent<MenuItemProps>(
        'onItemMouseOut',
        api,
        handler,
        payload => ({
          item: transformPropDataToSdkData(payload),
          type: 'itemMouseOut',
        }),
      ),
    onItemClick: (handler: ICorvidEventHandler<ICorvidMouseEvent>) =>
      registerCorvidMouseEvent<MenuItemProps>(
        'onItemClick',
        api,
        handler,
        payload => ({
          item: transformPropDataToSdkData(payload),
          type: 'itemMouseClick',
        }),
      ),
    onItemDblClick: (handler: ICorvidEventHandler<ICorvidMouseEvent>) =>
      registerCorvidMouseEvent<MenuItemProps>(
        'onItemDblClick',
        api,
        handler,
        payload => ({
          item: transformPropDataToSdkData(payload),
          type: 'itemMouseDblClick',
        }),
      ),
  };
};

export default composeSDKFactories([
  createMenuSdk,
  createA11ySdk({ a11yProperty: 'a11y' }),
]);
